import { Fragment } from "react";
import { Link } from "react-router-dom";

const AGREE_NAMES = { terms: "Terms and Conditions", "refund-policy": "Refund & Cancellation Policy", "privacy-policy": "Privacy Policy" };

export const LegalLinks = ({ pages = [], className = "", linkClass = "", prefix = "footer" }) => (
  pages.length > 0 && (
    <ul className={className} aria-label="Legal" data-testid={`${prefix}-legal-links`}>
      {pages.map((p) => <li key={p.slug}><Link to={p.path} className={linkClass} data-testid={`${prefix}-legal-${p.slug}`}>{p.label}</Link></li>)}
    </ul>
  )
);

export const MerchantBlock = ({ m, className = "", prefix = "footer" }) => (m ? (
  <address className={`not-italic leading-relaxed ${className}`} data-testid={`${prefix}-merchant-block`}>
    <p className="font-semibold" data-testid={`${prefix}-merchant-name`}>{m.legal_name}</p>
    {m.address && <p data-testid={`${prefix}-merchant-address`}>{m.address}</p>}
    {m.location && <p>{m.location}</p>}
    {m.email && <p><a href={`mailto:${m.email}`} className="underline" data-testid={`${prefix}-merchant-email`}>{m.email}</a></p>}
    {m.phone && <p data-testid={`${prefix}-merchant-phone`}>Tel: {m.phone}</p>}
    <p data-testid={`${prefix}-merchant-currency`}>{m.currency_note}</p>
  </address>
) : null);

const joinList = (items) => items.map((el, i) => (
  <Fragment key={i}>{i > 0 && (i === items.length - 1 ? " and " : ", ")}{el}</Fragment>
));

// Required checkout agreement: lists only the policies that are currently published.
export const PolicyAgreement = ({ pages = [], checked, onChange, testid }) => (
  <label className="flex items-start gap-3 text-sm">
    <input type="checkbox" className="mt-1 h-4 w-4" checked={!!checked} onChange={(e) => onChange(e.target.checked)} required data-testid={testid} />
    <span>I have read and agree to the {joinList(pages.filter((p) => AGREE_NAMES[p.slug]).map((p) => (
      <a key={p.slug} href={p.path} target="_blank" rel="noopener noreferrer" className="font-semibold text-burgundy underline" data-testid={`${testid}-link-${p.slug}`}>{AGREE_NAMES[p.slug]}</a>
    )))}.</span>
  </label>
);

export const PolicyLinksNote = ({ pages = [], className = "" }) => (pages.length > 0 && (
  <p className={`text-sm text-[#4A5568] ${className}`} data-testid="policy-links-note">Our policies: {joinList(pages.map((p) => (
    <Link key={p.slug} to={p.path} className="font-semibold text-burgundy underline" data-testid={`policy-note-link-${p.slug}`}>{p.label}</Link>
  )))}</p>
));
